import type { Beacon } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../../../utility/client';

export async function getBeacon(id: string) {
  const response = await Api.get<Beacon>(`/admin/v1/beacons/${id}`);
  return response.data;
}
